import type { DefaultOptionType } from '@/components/combobox/combobox';
import PriceUnitsCombobox from '@/components/combobox/price-units-combobox';
import LeftSidePanel from '@/components/left-side-panel';
import { Button } from '@lego/connect-components-react';
import type { Dispatch, RefObject, SetStateAction } from 'react';

type ResetNoveltyPricesSetupPanelProps = {
  selectedPriceUnits: DefaultOptionType[];
  setSelectedPriceUnits: Dispatch<SetStateAction<DefaultOptionType[]>>;
  onSubmit: () => void;
  isLoading: boolean;
  triggerRef: RefObject<HTMLButtonElement | null>;
};

const ResetNoveltyPricesSetupPanel = ({
  selectedPriceUnits,
  setSelectedPriceUnits,
  onSubmit,
  isLoading,
  triggerRef,
}: ResetNoveltyPricesSetupPanelProps) => {
  return (
    <LeftSidePanel title={'Reset Novelty Prices'}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          width: '100%',
        }}
      >
        <div style={{ width: '100%' }}>
          <PriceUnitsCombobox
            selectedItems={selectedPriceUnits}
            onSelect={(items) =>
              setSelectedPriceUnits(items as DefaultOptionType[])
            }
            title="Local Price List"
            isSingleSelect
            countryOnly
            isDisabled={isLoading}
          />
        </div>
        <Button
          ref={triggerRef}
          onClick={onSubmit}
          size="large"
          variant="primary"
          fullWidth
          style={{ boxSizing: 'border-box' }} //remove this when temporary-klik-provider is removed
          disabled={isLoading || selectedPriceUnits.length === 0}
          loading={isLoading}
        >
          Reset Novelty Prices
        </Button>
      </div>
    </LeftSidePanel>
  );
};

export default ResetNoveltyPricesSetupPanel;
